var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 7.00004H33.6663V10.3334H30.333V32C30.333 32.4421 30.1574 32.866 29.8449 33.1786C29.5323 33.4911 29.1084 33.6667 28.6663 33.6667H5.33301C4.89098 33.6667 4.46706 33.4911 4.1545 33.1786C3.84194 32.866 3.66634 32.4421 3.66634 32V10.3334H0.333008V7.00004H8.66634V2.00004C8.66634 1.55801 8.84194 1.13409 9.1545 0.821529C9.46706 0.508969 9.89098 0.333374 10.333 0.333374H23.6663C24.1084 0.333374 24.5323 0.508969 24.8449 0.821529C25.1574 1.13409 25.333 1.55801 25.333 2.00004V7.00004ZM26.9997 10.3334H6.99967V30.3334H26.9997V10.3334ZM11.9997 15.3334H15.333V25.3334H11.9997V15.3334ZM18.6663 15.3334H21.9997V25.3334H18.6663V15.3334ZM11.9997 3.66671V7.00004H21.9997V3.66671H11.9997Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/Trash-Can.e64714fd14789924012b548c50c7f005.svg";
export { ForwardRef as ReactComponent };